import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=c287b7a2&scoped=true&"
import script from "./OrderItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./OrderItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=c287b7a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c287b7a2",
  null
  
)

export default component.exports